module.exports = __webpack_public_path__ + "static/media/SourceHanSansCN-Medium.5ccaa01f.ttf";